import { CompanyEntity } from '../common/entity';

export enum BarcodeExportEntityType {
  product = 'product',
  productTransaction = 'productTransaction',
  order = 'order',
  bin = 'bin',
  container = 'container',
  lot = 'lot',
}

export enum BarcodeExportConfigurationEntityType {
  product = 'product',
  bin = 'bin',
  container = 'container',
  lot = 'lot',
}

export const barcodeExportEntityTypeToConfigurationEntityTypeMap: Record<
  BarcodeExportEntityType,
  BarcodeExportConfigurationEntityType
> = {
  [BarcodeExportEntityType.product]: BarcodeExportConfigurationEntityType.product,
  [BarcodeExportEntityType.productTransaction]: BarcodeExportConfigurationEntityType.product,
  [BarcodeExportEntityType.order]: BarcodeExportConfigurationEntityType.product,
  [BarcodeExportEntityType.bin]: BarcodeExportConfigurationEntityType.bin,
  [BarcodeExportEntityType.container]: BarcodeExportConfigurationEntityType.container,
  [BarcodeExportEntityType.lot]: BarcodeExportConfigurationEntityType.lot,
} as const;

export const BarcodeExportConfigurationField = {
  serial: 'serial',
  productNumber: 'productNumber',
  lotNumber: 'lotNumber',
  quantity: 'quantity',
  binName: 'binName',
  containerIdentifier: 'containerIdentifier',
} as const;

export type BarcodeExportConfigurationField =
  (typeof BarcodeExportConfigurationField)[keyof typeof BarcodeExportConfigurationField];

export const barcodeExportConfigurationEntityTypeFieldMap: Record<
  BarcodeExportConfigurationEntityType,
  readonly BarcodeExportConfigurationField[]
> = {
  [BarcodeExportConfigurationEntityType.product]: [
    BarcodeExportConfigurationField.productNumber,
    BarcodeExportConfigurationField.lotNumber,
    BarcodeExportConfigurationField.serial,
    BarcodeExportConfigurationField.quantity,
  ],
  [BarcodeExportConfigurationEntityType.bin]: [BarcodeExportConfigurationField.binName],
  [BarcodeExportConfigurationEntityType.container]: [BarcodeExportConfigurationField.containerIdentifier],
  [BarcodeExportConfigurationEntityType.lot]: [BarcodeExportConfigurationField.lotNumber],
} as const;

export const BarcodeExportConfigurationFormat = {
  code128: 'code128',
  code39: 'code39',
  qrCode: 'qrCode',
  dataMatrix: 'dataMatrix',
} as const;

export type BarcodeExportConfigurationFormat =
  (typeof BarcodeExportConfigurationFormat)[keyof typeof BarcodeExportConfigurationFormat];

export enum BarcodeExportConfigurationFileType {
  pdf = 'pdf',
}

export class BarcodeExportConfigurationEntry {
  id!: string;
  format!: BarcodeExportConfigurationFormat;
  field!: BarcodeExportConfigurationField;
  prefix?: string;
  suffix?: string;
  height!: number;
  horizontalMargin!: number;
  verticalMargin!: number;
  includeText!: boolean;
}

export class BarcodeExportConfiguration extends CompanyEntity {
  name!: string;
  fileType: BarcodeExportConfigurationFileType = BarcodeExportConfigurationFileType.pdf;
  entries: BarcodeExportConfigurationEntry[] = [];
  entityType: BarcodeExportConfigurationEntityType = BarcodeExportConfigurationEntityType.product;

  constructor(obj: any) {
    if (!obj.companyId) return;
    super(obj.companyId);
    Object.assign(this, obj);
  }
}
